import React, { useRef, useEffect } from "react";
import { closeIcon } from "../Icons";
import { getText } from "../../__utils__/textUtils";
import { feedbackTagPairs, feedbackTexts } from "./feedbackUtility";

interface FeedbackModalProps {
  feedback: boolean | null;
  open: boolean;
  setOpen: (open: boolean) => void;
  showMoreInsight: boolean;
  setShowMoreInsight: (show: boolean) => void;
  moreInsightValue: string;
  setMoreInsightValue: (value: string) => void;
  handleFeedbackTagClick: (comment: string) => Promise<void>;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  feedback,
  open,
  setOpen,
  showMoreInsight,
  setShowMoreInsight,
  moreInsightValue,
  setMoreInsightValue,
  handleFeedbackTagClick,
}) => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (open && scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [open, showMoreInsight]);

  if (!open) return null;

  return (
    <div className="feedback-modal-custom" ref={scrollRef}>
      <div className="feedback-modal-header">
        <div className="feedback-modal-title">
          {feedback === true
            ? getText("TELL_US_MORE_ABOUT_WHAT_YOU_LIKED")
            : getText("TELL_US_MORE_ABOUT_WHAT_YOU_DISLIKED")}
        </div>
        <button
          className="feedback-modal-close"
          aria-label="Close"
          onClick={() => setOpen(false)}
        >
          {closeIcon()}
        </button>
      </div>
      <div className="feedback-modal-tags">
        {feedbackTagPairs.map((pair, index) => (
          <span
            key={index}
            className="tag-chip"
            onClick={() =>
              handleFeedbackTagClick(
                feedback === true ? pair.like : pair.dislike
              )
            }
          >
            {feedback === true ? pair.like : pair.dislike}
          </span>
        ))}
        {feedback === false && (
          <span
            className="tag-chip"
            onClick={() =>
              handleFeedbackTagClick(feedbackTexts.ignoredLocation)
            }
          >
            {feedbackTexts.ignoredLocation}
          </span>
        )}
        <span className="tag-chip" onClick={() => setShowMoreInsight(true)}>
          {feedbackTexts.additionalFeedback}
        </span>
      </div>
      {showMoreInsight && (
        <div className="more-insight-section">
          <label className="insight-label">{getText("MORE_INSIGHTS")}</label>
          <input
            className="insight-input"
            type="text"
            placeholder={getText("SHARE_ANY_FEEDBACK_TO_IMPROVE_THE_CHATBOT")}
            value={moreInsightValue}
            onChange={(e) => setMoreInsightValue(e.target.value)}
            onKeyDown={async (e) => {
              if (e.key === "Enter" && moreInsightValue.trim()) {
                await handleFeedbackTagClick(moreInsightValue.trim());
                setShowMoreInsight(false);
                setMoreInsightValue("");
              }
            }}
          />
        </div>
      )}
    </div>
  );
};

export default FeedbackModal;
